import { firebaseAuth } from '../infra/firebase/init';

export const logoutUseCase = async () => {
  await firebaseAuth.signOut();
};
